<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" label-width="90px">
            <el-form-item label="借阅目的" prop="purpose">
                <el-select v-model="searchForm.purpose" clearable placeholder="请选择借阅目的">
                    <el-option
                            v-for="item in $dictUtils.getDictList('purpose_type')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="借阅状态" prop="applicationState">
                <el-select v-model="searchForm.applicationState" clearable placeholder="请选择借阅状态">
                    <el-option
                        v-for="item in $dictUtils.getDictList('application_state')"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审核人" prop="auditBy">
                <el-select v-model="searchForm.auditBy" clearable placeholder="请选择审核人">
                    <el-option
                        v-for="item in auditByList"
                        :key="item.createBy"
                        :label="item.createByName"
                        :value="item.createBy">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="申请人" prop="createBy">
                <el-select style="width: 100%;" v-model="searchForm.createBy" clearable placeholder="请选择申请人">
                    <el-option
                        v-for="item in createByList"
                        :key="item.createBy"
                        :label="item.createByName"
                        :value="item.createBy">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审核时间" prop="auditTime">
                <el-date-picker
                    v-model="searchForm.auditTime"
                    clearable
                    style="width: 100%"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="申请时间" prop="applicationTime">
                <el-date-picker
                        v-model="searchForm.applicationTime"
                        clearable
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="关键字" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" maxlength="20" placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="text_right p_all1">
            <el-button v-if="hasPermission('academic:applyFor:record:exportData')" size="small"
                       @click="exportData()"><i class="icon-piliangdaochu iconfont buIcon"/>
                批量导出
            </el-button>
        </div>
        <el-table
            :data="dataList"
            v-loading="loading"
            @selection-change="selectionChangeHandle"
            @sort-change="sortChangeHandle"
            size="small" height="100%"
            class="table" ref="multipleTable" row-key='id' border>
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="applicationOdd" label="借阅编号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createByName" label="借阅人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="purpose" label="借阅目的" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $dictUtils.getDictLabel("purpose_type", scope.row.purpose, '') }}
                </template>
            </el-table-column>
            <el-table-column prop="newApplicationContent" label="借阅内容" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationDate" sortable label="借阅开始时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationDay" sortable label="借阅天数" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationNum" sortable label="借阅数量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注说明" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicationState" label="借阅状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $dictUtils.getDictLabel("application_state", scope.row.applicationState, '') }}
                </template>
            </el-table-column>
            <el-table-column prop="returnDate" sortable label="归还时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="auditByName" label="审核人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" sortable label="审核时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="submitByName" label="申请人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="submitTime" sortable label="申请时间" show-overflow-tooltip></el-table-column>
            <el-table-column
                fixed="right"
                min-width="120px"
                label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('academic:applyFor:record:view')" type="text" size="small"
                               @click="view(scope.row, 'view')">详情
                    </el-button>
                    <el-button v-if="hasPermission('academic:applyFor:record:record')" type="text" size="small"
                               @click="recordData(scope.row)">审核记录
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <audit-records ref="auditRecords"></audit-records>
        <add-borrowing ref="addBorrowing" @refresh="refreshList(1,1)"></add-borrowing>
    </div>
</template>

<script>
import AuditRecords from "@/components/toExamine/auditRecords.vue";
import AddBorrowing from "@/views/modules/academic/applyFor/addBorrowing.vue";

export default {
    name: "record",
    components: {AddBorrowing, AuditRecords},
    data() {
        return {
            searchForm: {
                purpose: '',
                applicationState:'',
                auditBy:'',
                createBy:'',
                auditTime:[],
                createStartTime:'',
                createEndTime:'',
                applicationTime:[],
                submitStartTime:'',
                submitEndTime:'',
                keyword:'',
                orderBy:"",
                current: 1,
                size: 20,
            },
            total: 0,
            auditByList:[],
            createByList: [],

            loading: false,
            dataList: [],
            dataListSelect: [],
            searchFromData:{},
        }
    },

    mounted() {
        this.refreshList()
        this.getOtherData()
    },

    methods: {
        getOtherData(){
            this.$axios(this.api.academic.resourceapplicationAuditUserList).then(data => {
                if (data && data.status) {
                    this.auditByList = data.data
                }
            })
            this.$axios(this.api.academic.resourceapplicationApplicationUserList, {}).then(data => {
                if (data && data.status) {
                    this.createByList = data.data
                }
            })
        },

        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (this.searchForm.auditTime && this.searchForm.auditTime.length != 0) {
                this.searchForm.createStartTime = this.searchForm.auditTime[0]
                this.searchForm.createEndTime = this.searchForm.auditTime[1]
            } else {
                this.searchForm.createStartTime = ''
                this.searchForm.createEndTime = ''
            }
            if (this.searchForm.applicationTime && this.searchForm.applicationTime.length != 0) {
                this.searchForm.submitStartTime = this.searchForm.applicationTime[0]
                this.searchForm.submitEndTime = this.searchForm.applicationTime[1]
            } else {
                this.searchForm.submitStartTime = ''
                this.searchForm.submitEndTime = ''
            }
            this.loading = true
            this.searchFromData = this.searchForm
            this.$axios(this.api.academic.resourceapplicationApplicationList, this.searchForm).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    this.dataList.forEach(item=>{
                        let applicationList = item.applicationContent.split(',')
                        let newApplicationContent = []
                        applicationList.forEach(item2=>{
                            if (item2 == 0){
                                newApplicationContent.push('脱敏字段')
                            }
                            if (item2 == 1){
                                newApplicationContent.push('在线预览')
                            }
                            if (item2 == 2){
                                newApplicationContent.push('文件下载')
                            }
                        })
                        this.$set(item,'newApplicationContent',newApplicationContent.join(','))
                    })
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },
        //排序
        sortChangeHandle (obj) {
            obj.prop = this.getHumpLineName(obj.prop);
            if (obj.order === 'ascending') {
                this.searchForm.orderBy = obj.prop + ' asc'
            } else if (obj.order === 'descending') {
                this.searchForm.orderBy = obj.prop + ' desc'
            } else {
                this.searchForm.orderBy = ''
            }
            this.refreshList(1)
        },
        //批量导出
        exportData(){
            if (this.dataList.length == 0) {
                this.$message.warning('暂无可导出的数据！')
                return
            }
            let ids = this.dataListSelect.map(item => {
                return item.id
            })
            this.exportExcel(this.api.academic.resourceapplicationExport, {
                ids,
                ...this.searchFromData,
            }, '借阅台账信息', 'post')
        },

        //详情
        view(row){
            this.$refs.addBorrowing.init(row,'recordView')
        },

        //审核记录
        recordData(row){
            this.$refs.auditRecords.init(row.id)
        },
    },
}
</script>

<style scoped>

</style>
